module.exports = __webpack_public_path__ + "img/vessel-light-arrow.a652f385.svg";